export const JOB_VIEWED_CHANGED = 'job-viewed-changed';

export const notifyJobViewedChanged = (jobId) => {
    if (typeof window === 'undefined' || jobId == null || jobId === '') {
        return;
    }
    window.dispatchEvent(new CustomEvent(JOB_VIEWED_CHANGED, {
        detail: { jobId: String(jobId) },
    }));
};

export const removeJobFromUnseenSet = (unseenJobIds, jobId) => {
    if (!(unseenJobIds instanceof Set)) {
        return unseenJobIds;
    }
    const jobIdStr = String(jobId);
    if (!unseenJobIds.has(jobIdStr)) {
        return unseenJobIds;
    }
    const next = new Set(unseenJobIds);
    next.delete(jobIdStr);
    return next;
};
